import {IValidationRule} from '../../@interfaces/services/YupSchemeBuilder/IValidationRule';
import RequiredRule from './rules/RequiredRule';
import {StringArray} from '../../@interfaces/types';
import {Constructable} from '../../@types/instantable';
import NullableRule from './rules/NullableRule';
import MinRule from './rules/MinRule';
import MaxRule from './rules/MaxRule';
import NumericRule from './rules/NumericRule';

export default class RulesRepository {
    protected availableRules: Constructable<IValidationRule>[] = [
        RequiredRule,
        NullableRule,
        NumericRule,
        MinRule,
        MaxRule,
    ];

    protected cache: StringArray<IValidationRule> = {};

    getByName(declaration: string): IValidationRule | null {
        const rule = this.resolveRule(declaration);
        rule?.parseRuleDeclaration(declaration);

        return rule;
    }

    protected resolveRule(declaration: string): IValidationRule | null {
        const [name] = declaration.split(':');
        if (name in this.cache) {
            return this.cache[name];
        }

        for (const constructor of this.availableRules) {
            const instance = new constructor();
            this.cache[instance.getName()] = instance;
        }

        if (name in this.cache) {
            return this.cache[name];
        }

        return null;
    }
}
